import {Injectable} from '@angular/core';
import {SignalEntityQuery} from '../../state/signal-entity.store';
import {ShoppingCartState, ShoppingCartStore} from './shopping-cart-store';
import {ShoppingCartItem} from '../../models/underwriter.model';

@Injectable({
    providedIn: 'root'
})
export class ShoppingCartQuery extends SignalEntityQuery<ShoppingCartItem, ShoppingCartState>{
    constructor(protected store: ShoppingCartStore) {
        super(store);
    }

    getCartItemByClassItemId(class_id: number, item_id: string){
        return this.selectAll({
            filterBy: [
                entity => entity.item_id === item_id && entity.class_id === class_id
            ]
        });
    }
}
